import api from './api';
import { tokenService } from './tokenService';
import { UserLogin, LoginCredentials, UserRegister, AuthResponse, User, TokenResponse, UserProfile, ChangePassword } from '../types/auth';
import axios from 'axios';

const setAuthHeader = (token: TokenResponse | null) => {
  if (token) {
    api.defaults.headers.common['Authorization'] = `Bearer ${token.access}`;
  } else {
    delete api.defaults.headers.common['Authorization'];
  }
};

class AuthService {
  async login(credentials: LoginCredentials): Promise<AuthResponse> {
    try {
      const loginData: UserLogin = {
        email: credentials.email,
        password: credentials.password,
      };

      const response = await api.post<AuthResponse>('/auth/login/', loginData);

      const token: TokenResponse = {
        refresh: response.data.refresh,
        access: response.data.access,
      };

      tokenService.saveToken(token);
      setAuthHeader(token);

      return response.data;

    } catch (error) {
      tokenService.removeToken();
      setAuthHeader(null);
      throw error;
    }
  }

  async register(data: UserRegister): Promise<AuthResponse> {
    try {
      const response = await api.post<AuthResponse>('/auth/register/', data);

      const token: TokenResponse = {
        refresh: response.data.refresh,
        access: response.data.access,
      };

      tokenService.saveToken(token);
      setAuthHeader(token);

      return response.data;

    } catch (error) {
      throw error;
    }
  }

  async logout(): Promise<void> {
    try {
      await api.post('/auth/logout/');
    } finally {
      tokenService.removeToken();
      setAuthHeader(null);
    }
  }

  async getProfile(): Promise<User> {
    try {
      const response = await api.get<User>('/auth/profile/');
      const user = response.data;

      const acessosAssinante = user?.assinante_membership?.plano?.acessos;
      const acessosEmpresa = user?.empresa_membership?.plano?.acessos;

      const acessos =
        acessosAssinante ||
        acessosEmpresa ||
        [];

      localStorage.setItem("acessos", JSON.stringify(acessos));

      return user;

    } catch (error) {
      if (axios.isAxiosError(error) && error.response?.status === 401) {
        tokenService.removeToken();
        setAuthHeader(null);
      }
      throw error;
    }
  }


  async updateProfile(data: {
      nome_completo?: string;
      email?: string;
      new_password?: string;
      current_password?: string;
    }): Promise<User> {
      const response = await api.patch<User>('/users/profile/', data);
      return response.data;
  }

  async changePassword(data: ChangePassword): Promise<void> {
    await api.post('/auth/change-password/', data);
  }

  async sendResetPasswordLink(email: string): Promise<void> {
    await api.post('/auth/send-reset-password-link/', { login: email });
  }

  isAuthenticated(): boolean {
    const token = tokenService.getToken();
    if (token?.access) {
      setAuthHeader(token);
      return true;
    }
    return false;
  }

  getToken(): TokenResponse | null {
    return tokenService.getToken();
  }
}

export const authService = new AuthService(); 